import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FC, useEffect, useState } from "react";
import { List, TextField } from "../../../components/fields";
import { faClose, faSave } from "@fortawesome/free-solid-svg-icons";
import "./_styles.scss";
import { parseFloatWithDecimal } from "../../../utilities/stringUtils";

interface AwardsRowProps {
  name: string;
  value: string;
  readOnly?: boolean;
  options: any;
  onChange?: (name: string, value: string) => void;
  onDelete?: () => void;
}

const AwardsRow: FC<AwardsRowProps> = ({
  name,
  value = "1",
  options,
  readOnly = false,
  onChange = () => {},
  onDelete = () => {}
}) => {
  const [hasChanged, sethasChanged] = useState(false);
  const [currentName, setName] = useState(name);
  const [currentValue, setValue] = useState(value);

  useEffect(() => {
    setName(name);
    setValue(value);
  }, [name, value]);

  let hasValid =
    hasChanged &&
    currentName !== "" &&
    !(currentValue === "" || currentValue === "0");
  return (
    <div className="awards-row">
      <div>
        <List
          readOnly={readOnly}
          label={`Name`}
          value={currentName}
          options={options}
          onChange={(_: any, v: string) => {
            if (!v) return;
            sethasChanged(true);
            setName(v);
          }}
          getOptionLabel={(o) => {
            return o.toString();
          }}
          getOptionValue={(o) => {
            return o.toString();
          }}
          groupBy={(o: any) => {
            return `${o.substring(0, 2)}`;
          }}
          isOptionEqualToValue={(o: any, v: any) => {
            return `${o}` === `${v}`;
          }}
        />
      </div>

      <div>
        <TextField
          style={{ width: "100%" }}
          readOnly={readOnly}
          label={"Multiplier"}
          value={currentValue}
          type="number"
          minValue={1}
          onChange={(e: any) => {
            sethasChanged(true);
            setValue(
              parseFloatWithDecimal(e.currentTarget.value, 2).toString()
            );
          }}
        />
      </div>

      {!readOnly ? (
        <span
          onClick={() => {
            sethasChanged(false);
            if (!readOnly)
              hasValid ? onChange(currentName, currentValue) : onDelete();
          }}
        >
          {hasValid ? (
            <FontAwesomeIcon icon={faSave} />
          ) : (
            <FontAwesomeIcon icon={faClose} />
          )}
        </span>
      ) : (
        <></>
      )}
    </div>
  );
};

export default AwardsRow;
